document.addEventListener('DOMContentLoaded', () => {
  const swiper = new Swiper('.swiper.icons-slider', {
    slidesPerView: 1,
    grid: {
      rows: 2,
    },
    spaceBetween: 10,
    autoplay: {
      delay: 2500,
      disableOnInteraction: false,
    },
    breakpoints: {
      // when window width is >= 640px
      768: {
        loop: document.querySelectorAll('.swiper.icons-slider .swiper-slide').length > 4,
        slidesPerView: 4,
        spaceBetween: 20,
        grid: false,
        navigation: {
          enabled: true
        }
      }
    },
  });
  document.querySelector('.swiper.icons-slider .swiper-button-prev')?.addEventListener('click', () => {
    swiper.slidePrev()
  })

  document.querySelector('.swiper.icons-slider .swiper-button-next')?.addEventListener('click', () => {
    swiper.slideNext()
  })
})
